export default __webpack_public_path__ + "static/media/header-md.d3549e32.png";